import { FunctionComponent, lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import { Player } from "@lottiefiles/react-lottie-player";

import Loader from "src/assets/images/splash_screen_loader.json";

import { APP_PATHS, BASE_PATHS } from "src/Constant/path";

import RadarCheckProvider from "src/Context/RadarCheck";
import RadarProfileProvider from "src/Context/RadarProfile";
import RadarViewProfileProvider from "src/Context/RadarProfile/viewProfile";
import RadarRulesProvider from "src/Context/RadarRules";
import GetCardProvider from "src/Context/Billing/GetCard";
import AddCardProvider from "src/Context/Billing/AddCard";
import GetSubscriptionProvider from "src/Context/Billing/GetSubscription";
import DeleteCardProvider from "src/Context/Billing/DeleteCard";
import DefaultCardProvider from "src/Context/Billing/DefaultCard";
import RadarViewReportProvider from "src/Context/RadarProfile/viewReport";
import GetPlanProvider from "src/Context/Billing/GetPlan";
import NewSubscriptionProvider from "src/Context/Billing/NewSubscription";
import RegenerateApiKeyProvider from "src/Context/ApiKey";
import OverviewSummaryProvider from "src/Context/Dashboard/OverviewSummary";
import MostUsedRuleProvider from "src/Context/Dashboard/MostUsedRule";
import AnalyticsProvider from "src/Context/Dashboard/analytics";
import AddRadarRuleProvider from "src/Context/RadarRules/addRule";
import MostUsedCheckProvider from "src/Context/RadarAnalytics/MostUsedCheck";
import RiskDetectedProvider from "src/Context/RadarAnalytics/RiskDetected";
import GenderProvider from "src/Context/RadarAnalytics/Gender";
import LocationProvider from "src/Context/Dashboard/Location";
import RiskProfileProvider from "src/Context/RadarAnalytics/RiskProfile";
import ScreeningAlertProvider from "src/Context/BackOffice/ScreeningAlert";
import ViewScreeningAlertProvider from "src/Context/BackOffice/ViewScreeningAlert";
import UpdateStatusProvider from "src/Context/BackOffice/UpdateStatus";
import RequestUploadProvider from "src/Context/BackOffice/RequestUpload";

import PaystackAddCardProvider from "src/Context/Billing/Paystack";
import FlutterwaveAddCardProvider from "src/Context/Billing/Flutterwave";

import SpotlightPage from "src/Modules/pages/RadarSpotlight";
import GetUserProfileProvider from "src/Context/UserProfile";
import ConfigurationProvider from "src/Context/Settings/Configuration";
import MonitoringOverviewProvider from "src/Context/TransactionMonitoring/MonitoringOverview";
import FraudAlertProvider from "src/Context/TransactionMonitoring/FraudAlert";
import GrowthChartProvider from "src/Context/TransactionMonitoring/GrowthChart";
import ChangeStateProvider from "src/Context/TransactionMonitoring/ChangeState";
import AssignTransactionProvider from "src/Context/TransactionMonitoring/AssignTransaction";
import GetAssigneeProvider from "src/Context/TransactionMonitoring/GetAssignee";
import AlertExportProvider from "src/Context/TransactionMonitoring/AlertExport";
import FeedOverviewProvider from "src/Context/TransactionMonitoring/FeedOverview";
import TransactionFeedsProvider from "src/Context/TransactionMonitoring/TransactionFeeds";
import FeedExportProvider from "src/Context/TransactionMonitoring/FeedExport";
import TransactionDetailProvider from "src/Context/TransactionMonitoring/TransactionDetail";
import AccountActivityProvider from "src/Context/TransactionMonitoring/AccountActivity";
import ActivityLogsProvider from "src/Context/TransactionMonitoring/ActivityLogs";
import MonitoringDetailProvider from "src/Context/TransactionMonitoring/MonitoringDetails";
import AlertOverviewProvider from "src/Context/TransactionMonitoring/AlertOverview";
import FraudAlertDetailProvider from "src/Context/TransactionMonitoring/FraudAlertDetail";
import AlertMonitoringDetailProvider from "src/Context/TransactionMonitoring/AlertMonitoringDetails";
import SaveEntityProvider from "src/Context/RadarCheck/SaveEntity";

import AddMonitoringProvider from "src/Context/UserMonitoring/addMonitoring";
import MonitoringProvider from "src/Context/UserMonitoring/monitoring";
import RemoveMonitoringProvider from "src/Context/UserMonitoring/removeMonitoring";
import ViewMonitoringDetailProvider from "src/Context/UserMonitoring/viewMonitoringDetail";
import ViewMonitoringHistoryProvider from "src/Context/UserMonitoring/viewContinousMonitoring";
import AccountTrailProvider from "src/Context/BackOffice/AccountTrail";
import RolesProvider from "src/Context/Settings/Roles";
import ThresholdProvider from "src/Context/Settings/thresholdConfiguration";
import MpesaProvider from "src/Context/Billing/mpesa";
import MembersProvider from "src/Context/Settings/Members";
import EditTrailProvider from "src/Context/Settings/EditTrail";
import DeleteMemberProvider from "src/Context/Settings/DeleteMember";
import AddMemberProvider from "src/Context/Settings/AddMember";
import ReassignRoleProvider from "src/Context/Settings/ReassignRole";
import NotificationProvider from "src/Context/Settings/Notification";
import UpdateNotificationProvider from "src/Context/Settings/UpdateNotification";
import AddRoleProvider from "src/Context/Settings/AddRole";
import PermissionsProvider from "src/Context/Settings/Permissions";
import UpdateProfileProvider from "src/Context/UserProfile/UpdateProfile";
import BulkTransactionMonitoringProvider from "src/Context/TransactionMonitoring/UploadTM";
import MonitorOngoingBulkTransactionProvider from "src/Context/TransactionMonitoring/MonitorOngoingBulkTransaction";
import GetBulkRecordProvider from "src/Context/RadarCheck/GetBulkRecord";
import SDKProvider from "src/Context/ApiKey/sdk";
import BiometricProvider from "src/Context/ApiKey/biometric";
import CustomBillingProvider from "src/Context/Billing/CustomBilling";
import RadarTransactionRulesProvider from "src/Context/RadarRules/transactionRules";
import RemoveBulkMonitoringProvider from "src/Context/UserMonitoring/removeBulkMonitoring";
import AddBulkMonitoringProvider from "src/Context/UserMonitoring/addBulkMonitoring";
import GetBulkUserMonitoringRecordsProvider from "src/Context/UserMonitoring/bulkMonitoring";
import GetMonitoringBulkProfilesProvider from "src/Context/UserMonitoring/viewMonitoringBulkProfiles";
import GetUserMonitoringBulkRecordProvider from "src/Context/UserMonitoring/getBulkRecords";
import ErrorBoundary from "src/ErrorBoundary";
import CheckPermission from "src/Routes/CheckPermission";
import RolesAndPermissionConfigProvider from "src/Context/Settings/RolesAndPermissionConfig";
import StatusBulkUpdateProvider from "src/Context/BackOffice/statusBulkUpdate";
import UpdateProfileRuleProvider from "src/Context/BackOffice/UpdateProfileRule";
import TransactionAssigneesProvider from "src/Context/TransactionMonitoring/TransactionAssignees";
import MyAssignedTransactionProvider from "src/Context/TransactionMonitoring/MyAssignedTransaction";
import AssigneesTransactionProvider from "src/Context/TransactionMonitoring/AssigneeTransactions";
import UnAssignTransactionProvider from "src/Context/TransactionMonitoring/UnassignTransaction";
import TM_MappingProvider from "src/Context/Settings/TM_Mapping";
import ManualAttributeProvider from "src/Context/TransactionMonitoring/ManualAttribute";
import DataFrequencyProvider from "src/Context/TransactionMonitoring/DataFrequency";
import SpotlightProvider from "src/Context/Radarspotlight";
import AddTeamProvider from "src/Context/Settings/AddTeam";
import TeamsProvider from "src/Context/Settings/Teams";
import DeleteTeamProvider from "src/Context/Settings/DeleteTeam";
import DeleteTeamTransactionProvider from "src/Context/Settings/DeleteTeamTransaction";
import WebhookUpdateProvider from "src/Context/ApiKey/webhook";
import UpdateScoreProvider from "src/Context/RadarRules/editScore";
import DeleteGroupProvider from "src/Context/Settings/DeleteGroup";
import AMLConfigurationProvider from "src/Context/ApiKey/aml_configuration";
import FeedbackLoopProvider from "src/Context/TransactionMonitoring/FeedbackLoop";

// Spotlight
// const SpotlightPage = lazy(() => import('src/Modules/pages/RadarSpotlight'));

// Dashboard
const DashboardPage = lazy(() => import("src/Modules/pages/Dashboard"));

// RadarCheck
const RadarCheckPage = lazy(() => import("src/Modules/pages/RadarCheck"));

// RadarProfile
const RadarProfilePage = lazy(() => import("src/Modules/pages/RadarProfile"));
const RadarViewProfilePage = lazy(
  () => import("src/Modules/pages/RadarProfile/ViewProfile"),
);
const RadarViewBulkProfilePage = lazy(
  () => import("src/Modules/pages/RadarProfile/ViewBulkRecord"),
);

// RadarRules
const RadarRulesPage = lazy(() => import("src/Modules/pages/RadarRules"));

// Wallet
const WalletPage = lazy(() => import("src/Modules/pages/Wallet"));

// ApiKeys
const ApiKeysPage = lazy(() => import("src/Modules/pages/API_SDK"));

// RadarReport
const RadarReportPage = lazy(() => import("src/Modules/pages/RadarAnalytics"));

// Back Office
const ScreeningAlertPage = lazy(
  () => import("src/Modules/pages/BackOffice/ScreeningAlert"),
);
const ViewScreeningAlertPage = lazy(
  () => import("src/Modules/pages/BackOffice/ViewScreeningAlert"),
);
const UserMonitoringPage = lazy(
  () => import("src/Modules/pages/BackOffice/UserMonitoring"),
);
const ViewMonitoringPage = lazy(
  () => import("src/Modules/pages/BackOffice/ViewMonitoring"),
);
const ViewScreeningAlertBulkProfilePage = lazy(
  () => import("src/Modules/pages/BackOffice/ViewScreeningAlertBulkRecord"),
);
const ViewUserMonitoringBulkProfilePage = lazy(
  () => import("src/Modules/pages/BackOffice/ViewUserMonitoringBulkRecord"),
);

// settings
const SettingsPage = lazy(() => import("src/Modules/pages/Settings"));

// Transaction Monitoring
const TM_DashboardPage = lazy(
  () => import("src/Modules/pages/TransactionMonitoring/Dashboard"),
);
const TM_FraudPage = lazy(
  () => import("src/Modules/pages/TransactionMonitoring/FraudAlerts"),
);
const TM_ViewFraudPage = lazy(
  () => import("src/Modules/pages/TransactionMonitoring/FraudAlerts/ViewAlert"),
);
const TM_FeedPage = lazy(
  () => import("src/Modules/pages/TransactionMonitoring/Feeds"),
);
const TM_ViewFeedPage = lazy(
  () => import("src/Modules/pages/TransactionMonitoring/Feeds/ViewFeed"),
);
const TM_AssignPage = lazy(
  () => import("src/Modules/pages/TransactionMonitoring/Assign"),
);
const TM_AssigneeTransactionPage = lazy(
  () =>
    import(
      "src/Modules/pages/TransactionMonitoring/Assign/AssigneesTransaction"
    ),
);
const TM_TeamAssigneeTransactionPage = lazy(
  () =>
    import(
      "src/Modules/pages/TransactionMonitoring/Assign/TeamAssigneesTransaction"
    ),
);

const AppRoute: FunctionComponent<Record<string, never>> = () => {
  return (
    <Routes>
      <Route path={`/`}>
        <Route path="">
          <Route
            path=""
            element={
              <Navigate
                to={`${BASE_PATHS.APP}/${APP_PATHS.SPOTLIGHT}`}
                replace
              />
            }
          />
          <Route
            path="app"
            element={<Navigate to={`${APP_PATHS.SPOTLIGHT}`} replace />}
          />
        </Route>
        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.SPOTLIGHT}`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <ErrorBoundary>
                <SpotlightProvider>
                  <SpotlightPage />
                </SpotlightProvider>
              </ErrorBoundary>
            </Suspense>
          }
        />
        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.DASHBOARD}`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <AnalyticsProvider>
                <OverviewSummaryProvider>
                  <MostUsedRuleProvider>
                    <RadarProfileProvider>
                      <ErrorBoundary>
                        <DashboardPage />
                      </ErrorBoundary>
                    </RadarProfileProvider>
                  </MostUsedRuleProvider>
                </OverviewSummaryProvider>
              </AnalyticsProvider>
            </Suspense>
          }
        />
        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.RADAR_CHECK}`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <CheckPermission permission={["RADAR_CHECK_SCREENING"]}>
                <RadarCheckProvider>
                  <SaveEntityProvider>
                    <ErrorBoundary>
                      <RadarCheckPage />
                    </ErrorBoundary>
                  </SaveEntityProvider>
                </RadarCheckProvider>
              </CheckPermission>
            </Suspense>
          }
        />
        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.CHECK_HISTORY}`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <CheckPermission permission={["RADAR_PROFILE_VIEW"]}>
                <RadarProfileProvider>
                  <ErrorBoundary>
                    <RadarProfilePage />
                  </ErrorBoundary>
                </RadarProfileProvider>
              </CheckPermission>
            </Suspense>
          }
        />
        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.CHECK_HISTORY}/:id`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <CheckPermission permission={["RADAR_PROFILE_VIEW"]}>
                <RadarViewProfileProvider>
                  <RadarViewReportProvider>
                    <ErrorBoundary>
                      <RadarViewProfilePage />
                    </ErrorBoundary>
                  </RadarViewReportProvider>
                </RadarViewProfileProvider>
              </CheckPermission>
            </Suspense>
          }
        />
        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.CHECK_HISTORY}/bulk/:id`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <CheckPermission permission={["RADAR_PROFILE_VIEW"]}>
                <GetUserProfileProvider>
                  <RadarProfileProvider>
                    <GetBulkRecordProvider>
                      <ErrorBoundary>
                        <RadarViewBulkProfilePage />
                      </ErrorBoundary>
                    </GetBulkRecordProvider>
                  </RadarProfileProvider>
                </GetUserProfileProvider>
              </CheckPermission>
            </Suspense>
          }
        />
        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.RADAR_RULES}`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <RadarRulesProvider>
                <AddRadarRuleProvider>
                  <RadarTransactionRulesProvider>
                    <UpdateScoreProvider>
                      <ErrorBoundary>
                        <RadarRulesPage />
                      </ErrorBoundary>
                    </UpdateScoreProvider>
                  </RadarTransactionRulesProvider>
                </AddRadarRuleProvider>
              </RadarRulesProvider>
            </Suspense>
          }
        />
        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.WALLET}`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <GetSubscriptionProvider>
                <MpesaProvider>
                  <GetPlanProvider>
                    <NewSubscriptionProvider>
                      <CustomBillingProvider>
                        <GetCardProvider>
                          <AddCardProvider>
                            <PaystackAddCardProvider>
                              <FlutterwaveAddCardProvider>
                                <DeleteCardProvider>
                                  <DefaultCardProvider>
                                    <ErrorBoundary>
                                      <WalletPage />
                                    </ErrorBoundary>
                                  </DefaultCardProvider>
                                </DeleteCardProvider>
                              </FlutterwaveAddCardProvider>
                            </PaystackAddCardProvider>
                          </AddCardProvider>
                        </GetCardProvider>
                      </CustomBillingProvider>
                    </NewSubscriptionProvider>
                  </GetPlanProvider>
                </MpesaProvider>
              </GetSubscriptionProvider>
            </Suspense>
          }
        />
        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.API_KEYS}`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <RegenerateApiKeyProvider>
                <SDKProvider>
                  <BiometricProvider>
                    <RadarViewReportProvider>
                      <WebhookUpdateProvider>
                        <AMLConfigurationProvider>
                          <ErrorBoundary>
                            <ApiKeysPage />
                          </ErrorBoundary>
                        </AMLConfigurationProvider>
                      </WebhookUpdateProvider>
                    </RadarViewReportProvider>
                  </BiometricProvider>
                </SDKProvider>
              </RegenerateApiKeyProvider>
            </Suspense>
          }
        />

        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.RADAR_ANALYTICS}`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <CheckPermission permission={["RADAR_ANALYTICS_VIEW"]}>
                <OverviewSummaryProvider>
                  <RiskDetectedProvider>
                    <AnalyticsProvider>
                      <MostUsedRuleProvider>
                        <MostUsedCheckProvider>
                          <GenderProvider>
                            <LocationProvider>
                              <RiskProfileProvider>
                                <ErrorBoundary>
                                  <RadarReportPage />
                                </ErrorBoundary>
                              </RiskProfileProvider>
                            </LocationProvider>
                          </GenderProvider>
                        </MostUsedCheckProvider>
                      </MostUsedRuleProvider>
                    </AnalyticsProvider>
                  </RiskDetectedProvider>
                </OverviewSummaryProvider>
              </CheckPermission>
            </Suspense>
          }
        />
        <Route
          path={`${BASE_PATHS.APP}/${APP_PATHS.SETTINGS}`}
          element={
            <Suspense
              fallback={
                <Box
                  textAlign={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"80%"}
                  position={"fixed"}
                  width={"80%"}
                  margin={"0px auto"}
                >
                  <Player
                    src={Loader}
                    style={{ width: "100px" }}
                    className="player"
                    loop
                    autoplay
                  />
                </Box>
              }
            >
              <ErrorBoundary>
                <GetUserProfileProvider>
                  <UpdateProfileProvider>
                    <ConfigurationProvider>
                      <ThresholdProvider>
                        <EditTrailProvider>
                          <NotificationProvider>
                            <UpdateNotificationProvider>
                              <RolesProvider>
                                <PermissionsProvider>
                                  <MembersProvider>
                                    <AddMemberProvider>
                                      <TeamsProvider>
                                        <AddTeamProvider>
                                          <DeleteTeamProvider>
                                            <DeleteMemberProvider>
                                              <AddRoleProvider>
                                                <ReassignRoleProvider>
                                                  <RolesAndPermissionConfigProvider>
                                                    <TM_MappingProvider>
                                                      <UnAssignTransactionProvider>
                                                        <DeleteTeamTransactionProvider>
                                                          <DeleteGroupProvider>
                                                            <ManualAttributeProvider>
                                                              <DataFrequencyProvider>
                                                                <SettingsPage />
                                                              </DataFrequencyProvider>
                                                            </ManualAttributeProvider>
                                                          </DeleteGroupProvider>
                                                        </DeleteTeamTransactionProvider>
                                                      </UnAssignTransactionProvider>
                                                    </TM_MappingProvider>
                                                  </RolesAndPermissionConfigProvider>
                                                </ReassignRoleProvider>
                                              </AddRoleProvider>
                                            </DeleteMemberProvider>
                                          </DeleteTeamProvider>
                                        </AddTeamProvider>
                                      </TeamsProvider>
                                    </AddMemberProvider>
                                  </MembersProvider>
                                </PermissionsProvider>
                              </RolesProvider>
                            </UpdateNotificationProvider>
                          </NotificationProvider>
                        </EditTrailProvider>
                      </ThresholdProvider>
                    </ConfigurationProvider>
                  </UpdateProfileProvider>
                </GetUserProfileProvider>
              </ErrorBoundary>
            </Suspense>
          }
        />
        <Route path={`${BASE_PATHS.APP}/${APP_PATHS.BACK_OFFICE}`}>
          <Route path="screening-alert">
            <Route
              path=""
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["BACK_OFFICE_SCREENING_ALERT_VIEW"]}
                  >
                    <ScreeningAlertProvider>
                      <AddBulkMonitoringProvider>
                        <StatusBulkUpdateProvider>
                          <ErrorBoundary>
                            <ScreeningAlertPage />
                          </ErrorBoundary>
                        </StatusBulkUpdateProvider>
                      </AddBulkMonitoringProvider>
                    </ScreeningAlertProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
            <Route
              path=":id"
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["BACK_OFFICE_SCREENING_ALERT_VIEW"]}
                  >
                    <ViewScreeningAlertProvider>
                      <AccountTrailProvider>
                        <UpdateStatusProvider>
                          <RequestUploadProvider>
                            <AddMonitoringProvider>
                              <AddBulkMonitoringProvider>
                                <RemoveMonitoringProvider>
                                  <UpdateProfileRuleProvider>
                                    <ErrorBoundary>
                                      <ViewScreeningAlertPage />
                                    </ErrorBoundary>
                                  </UpdateProfileRuleProvider>
                                </RemoveMonitoringProvider>
                              </AddBulkMonitoringProvider>
                            </AddMonitoringProvider>
                          </RequestUploadProvider>
                        </UpdateStatusProvider>
                      </AccountTrailProvider>
                    </ViewScreeningAlertProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
            <Route
              path="bulk/:id"
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["BACK_OFFICE_SCREENING_ALERT_VIEW"]}
                  >
                    <GetUserProfileProvider>
                      <RadarProfileProvider>
                        <GetUserMonitoringBulkRecordProvider>
                          <AddBulkMonitoringProvider>
                            <RemoveBulkMonitoringProvider>
                              <ErrorBoundary>
                                <ViewScreeningAlertBulkProfilePage />
                              </ErrorBoundary>
                            </RemoveBulkMonitoringProvider>
                          </AddBulkMonitoringProvider>
                        </GetUserMonitoringBulkRecordProvider>
                      </RadarProfileProvider>
                    </GetUserProfileProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
          </Route>
          <Route path="user-monitoring">
            <Route
              path=""
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["BACK_OFFICE_USER_MONITORING_VIEW"]}
                  >
                    <ErrorBoundary>
                      <MonitoringProvider>
                        <GetBulkUserMonitoringRecordsProvider>
                          <RemoveBulkMonitoringProvider>
                            <UserMonitoringPage />
                          </RemoveBulkMonitoringProvider>
                        </GetBulkUserMonitoringRecordsProvider>
                      </MonitoringProvider>
                    </ErrorBoundary>
                  </CheckPermission>
                </Suspense>
              }
            />
            <Route
              path=":id"
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["BACK_OFFICE_USER_MONITORING_VIEW"]}
                  >
                    <ViewMonitoringDetailProvider>
                      <ViewMonitoringHistoryProvider>
                        <AddMonitoringProvider>
                          <AddBulkMonitoringProvider>
                            <RemoveMonitoringProvider>
                              <ErrorBoundary>
                                <ViewMonitoringPage />
                              </ErrorBoundary>
                            </RemoveMonitoringProvider>
                          </AddBulkMonitoringProvider>
                        </AddMonitoringProvider>
                      </ViewMonitoringHistoryProvider>
                    </ViewMonitoringDetailProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
            <Route
              path="bulk/:id"
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["BACK_OFFICE_USER_MONITORING_VIEW"]}
                  >
                    <GetMonitoringBulkProfilesProvider>
                      <GetUserProfileProvider>
                        <RadarProfileProvider>
                          <GetBulkRecordProvider>
                            <AddBulkMonitoringProvider>
                              <RemoveBulkMonitoringProvider>
                                <ErrorBoundary>
                                  <ViewUserMonitoringBulkProfilePage />
                                </ErrorBoundary>
                              </RemoveBulkMonitoringProvider>
                            </AddBulkMonitoringProvider>
                          </GetBulkRecordProvider>
                        </RadarProfileProvider>
                      </GetUserProfileProvider>
                    </GetMonitoringBulkProfilesProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
          </Route>
        </Route>
        <Route path={`${BASE_PATHS.APP}/${APP_PATHS.TRANSACTION_MONITORING}`}>
          <Route path="dashboard-overview">
            <Route
              path=""
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["TRANSACTION_MONITORING_DASHBOARD_VIEW"]}
                  >
                    <MonitoringOverviewProvider>
                      <FraudAlertProvider>
                        <GrowthChartProvider>
                          <ChangeStateProvider>
                            <AssignTransactionProvider>
                              <GetAssigneeProvider>
                                <AlertExportProvider>
                                  <BulkTransactionMonitoringProvider>
                                    <ErrorBoundary>
                                      <TM_DashboardPage />
                                    </ErrorBoundary>
                                  </BulkTransactionMonitoringProvider>
                                </AlertExportProvider>
                              </GetAssigneeProvider>
                            </AssignTransactionProvider>
                          </ChangeStateProvider>
                        </GrowthChartProvider>
                      </FraudAlertProvider>
                    </MonitoringOverviewProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
          </Route>
          <Route path="feeds">
            <Route
              path=""
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["TRANSACTION_MONITORING_FEEDS"]}
                  >
                    <MonitorOngoingBulkTransactionProvider>
                      <FeedOverviewProvider>
                        <TransactionFeedsProvider>
                          <FeedExportProvider>
                            <GetAssigneeProvider>
                              {/* <TeamsProvider> */}
                              <AssignTransactionProvider>
                                <UnAssignTransactionProvider>
                                  <ChangeStateProvider>
                                    <BulkTransactionMonitoringProvider>
                                      <TM_MappingProvider>
                                        <ManualAttributeProvider>
                                          <TransactionAssigneesProvider>
                                            <ErrorBoundary>
                                              <TM_FeedPage />
                                            </ErrorBoundary>
                                          </TransactionAssigneesProvider>
                                        </ManualAttributeProvider>
                                      </TM_MappingProvider>
                                    </BulkTransactionMonitoringProvider>
                                  </ChangeStateProvider>
                                </UnAssignTransactionProvider>
                              </AssignTransactionProvider>
                              {/* </TeamsProvider> */}
                            </GetAssigneeProvider>
                          </FeedExportProvider>
                        </TransactionFeedsProvider>
                      </FeedOverviewProvider>
                    </MonitorOngoingBulkTransactionProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
            <Route
              path=":id/view"
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["TRANSACTION_MONITORING_FEEDS"]}
                  >
                    <TransactionDetailProvider>
                      <AccountActivityProvider>
                        <ActivityLogsProvider>
                          <MonitoringDetailProvider>
                            <GetAssigneeProvider>
                              {/* <TeamsProvider> */}
                              <AssignTransactionProvider>
                                <UnAssignTransactionProvider>
                                  <FeedExportProvider>
                                    <ChangeStateProvider>
                                      <TransactionAssigneesProvider>
                                        <ErrorBoundary>
                                          <TM_ViewFeedPage />
                                        </ErrorBoundary>
                                      </TransactionAssigneesProvider>
                                    </ChangeStateProvider>
                                  </FeedExportProvider>
                                </UnAssignTransactionProvider>
                              </AssignTransactionProvider>
                              {/* </TeamsProvider> */}
                            </GetAssigneeProvider>
                          </MonitoringDetailProvider>
                        </ActivityLogsProvider>
                      </AccountActivityProvider>
                    </TransactionDetailProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
          </Route>
          <Route path="fraud-alerts">
            <Route
              path=""
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["TRANSACTION_MONITORING_FRAUD_ALERT"]}
                  >
                    <FraudAlertProvider>
                      <AlertOverviewProvider>
                        <AlertExportProvider>
                          <ChangeStateProvider>
                            <AssignTransactionProvider>
                              <GetAssigneeProvider>
                                <ErrorBoundary>
                                  <TM_FraudPage />
                                </ErrorBoundary>
                              </GetAssigneeProvider>
                            </AssignTransactionProvider>
                          </ChangeStateProvider>
                        </AlertExportProvider>
                      </AlertOverviewProvider>
                    </FraudAlertProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
            <Route
              path=":id/view/:refId"
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission
                    permission={["TRANSACTION_MONITORING_FRAUD_ALERT"]}
                  >
                    <FraudAlertDetailProvider>
                      <AlertMonitoringDetailProvider>
                        <GetAssigneeProvider>
                          <ChangeStateProvider>
                            <AlertExportProvider>
                              <AssignTransactionProvider>
                                <FeedbackLoopProvider>
                                  <ErrorBoundary>
                                    <TM_ViewFraudPage />
                                  </ErrorBoundary>
                                </FeedbackLoopProvider>
                              </AssignTransactionProvider>
                            </AlertExportProvider>
                          </ChangeStateProvider>
                        </GetAssigneeProvider>
                      </AlertMonitoringDetailProvider>
                    </FraudAlertDetailProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
          </Route>
          <Route path="assign">
            <Route
              path=""
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <CheckPermission permission={["ASSIGN_TRANSACTION"]}>
                    <TransactionAssigneesProvider>
                      <MyAssignedTransactionProvider>
                        <TeamsProvider>
                          <TM_AssignPage />
                        </TeamsProvider>
                      </MyAssignedTransactionProvider>
                    </TransactionAssigneesProvider>
                  </CheckPermission>
                </Suspense>
              }
            />
            <Route
              path=":id/individual-assignment"
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <GetAssigneeProvider>
                    <AssignTransactionProvider>
                      <UnAssignTransactionProvider>
                        <AssigneesTransactionProvider>
                          <TeamsProvider>
                            <TransactionAssigneesProvider>
                              <TM_AssigneeTransactionPage />
                            </TransactionAssigneesProvider>
                          </TeamsProvider>
                        </AssigneesTransactionProvider>
                      </UnAssignTransactionProvider>
                    </AssignTransactionProvider>
                  </GetAssigneeProvider>
                </Suspense>
              }
            />
            <Route
              path=":id/team-assignment"
              element={
                <Suspense
                  fallback={
                    <Box
                      textAlign={"center"}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      height={"80%"}
                      position={"fixed"}
                      width={"80%"}
                      margin={"0px auto"}
                    >
                      <Player
                        src={Loader}
                        style={{ width: "100px" }}
                        className="player"
                        loop
                        autoplay
                      />
                    </Box>
                  }
                >
                  <GetAssigneeProvider>
                    <AssignTransactionProvider>
                      <UnAssignTransactionProvider>
                        <AssigneesTransactionProvider>
                          <TeamsProvider>
                            <TransactionAssigneesProvider>
                              <TM_TeamAssigneeTransactionPage />
                            </TransactionAssigneesProvider>
                          </TeamsProvider>
                        </AssigneesTransactionProvider>
                      </UnAssignTransactionProvider>
                    </AssignTransactionProvider>
                  </GetAssigneeProvider>
                </Suspense>
              }
            />
          </Route>
        </Route>
      </Route>
      <Route
        path="*"
        element={
          <div
            style={{
              width: "50%",
              margin: "5em auto",
              textAlign: "center",
            }}
          >
            <p>Oopppss, you seem to be lost</p>
          </div>
        }
      />
    </Routes>
  );
};

export default AppRoute;
